<template>
	<div class="website-report" v-if="customerId">
		<el-row class="title" type="flex" align="middle">
			<h3>网站数据报告</h3>
			<sky-dropdown-select
				class="site-list"
				@change="changeSite"
				v-model="serviceSiteId"
				:options="websiteList"
				:props="{ label: 'name', value: 'id' }"
			></sky-dropdown-select>
		</el-row>
		<div v-if="isShowWebsite">
			<div class="condition">
				<time-range @change="setQuery" v-model="timeType"> </time-range>
				<div>
					<el-checkbox @change="setQuery" v-model="isFilterCountry"
						>排除中国大陆（不含港澳台）</el-checkbox
					>
					<el-tooltip effect="dark" placement="top" content="勾选后影响以下所有数据统计">
						<ig-icon name="tishi"></ig-icon>
					</el-tooltip>
				</div>
			</div>
			<ga-base-chart ref="baseChart" class="card" :condition="condition"></ga-base-chart>
			<el-row :gutter="24">
				<el-col :span="elColSpan">
					<ga-channel-chart class="card" :condition="getChannelCondition"></ga-channel-chart>
				</el-col>
				<el-col :span="12" v-show="status === 1">
					<ga-time-chart class="card" :condition="condition"></ga-time-chart>
				</el-col>
			</el-row>
			<el-row :gutter="24">
				<el-col :span="24">
					<ga-map-chart class="card map" :condition="condition"></ga-map-chart>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<ga-site-chart class="card" :condition="condition"></ga-site-chart>
				</el-col>
			</el-row>
		</div>
		<div v-else>
			<div class="hint">敬请期待</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import skyDropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';
import timeRange from '@/components/tools/time_range';
import { getWebsiteByCustomer } from '@/backend/services/account/service';
import gaBaseChart from '@/components/website/ga_card/ga_base_data';
import gaChannelChart from '@/components/website/ga_card/ga_channel';
import gaMapChart from '@/components/website/ga_card/ga_map';
import gaSiteChart from '@/components/website/ga_card/ga_site';
import gaTimeChart from '@/components/website/ga_card/ga_timeline';
export default {
	name: 'website_report',
	components: {
		skyDropdownSelect,
		timeRange,
		gaBaseChart,
		gaChannelChart,
		gaMapChart,
		gaSiteChart,
		gaTimeChart,
	},
	data() {
		return {
			serviceSiteId: '',
			timeType: 3,
			condition: {},
			status: '',
			websiteList: [],
			elColSpan: 12,
			isFilterCountry: false,
		};
	},
	mounted() {},
	computed: {
		...mapGetters(['customerId']),
		getChannelCondition() {
			return Object.assign({}, this.condition, {
				dataType: [1, 2, 3, 4, 5, 6, 7, 8, 9, 11],
			});
		},
		isShowWebsite() {
			if (this.condition && this.condition.status === 0) {
				return false;
			} else {
				return true;
			}
		},
	},
	watch: {
		customerId: {
			async handler(val) {
				let id = this.$route.query.id;
				let name = this.$route.query.name;
				if (id && name) {
					this.$store.commit('SET_CUSTOMERID', id);
					this.$store.commit('SET_CUSOMERNAME', name);
				}
				if (val || (id && name)) {
					this.getWebsite(val);
				} else {
					this.$message.warning('您需要先选择一个客户');
					this.$showCustomerDialog();
				}
			},
			immediate: true,
		},
	},
	methods: {
		changeSite() {
			this.setQuery();
		},
		setQuery() {
			let { customerId, websiteList, serviceSiteId, timeType, status, isFilterCountry } = this;

			status = websiteList.filter(item => item.id === serviceSiteId)[0].status;

			this.elColSpan = status === 1 ? 12 : 24;

			this.condition = {
				customerId: customerId, // 客户id
				serviceSiteId: serviceSiteId, // 网站id
				timeType: timeType, // 时间类型
				status: status, // 网站类型
				isFilterCountry: isFilterCountry ? 1 : 0,
				sortName: 'visitorCount',
				sortType: 'desc',
			};

			this.$nextTick(() => {
				this.$refs.line && this.$refs.line.initCharts(this.condition);
			});
		},
		async getWebsite(id) {
			// 网站下拉数据
			let result = await getWebsiteByCustomer({
				customerId: id,
			});
			this.websiteList = result.data;
			if (result.data.length == 0) return false;
			this.serviceSiteId = result.data[0].id;
			this.status = result.data[0].status;
			this.setQuery();
		},
	},
};
</script>

<style scoped lang="scss">
.title {
	background: #fff;
	padding: 0 20px;
}
.condition {
	background: #fff;
	padding: 10px 20px;
	margin-bottom: 10px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.card {
	margin-top: 10px;
}
.site-list {
	margin-left: 20px;
}

.hint {
	width: 100%;
	height: 200px;
	font-size: 18px;
	color: #ccc;
	line-height: 200px;
	text-align: center;
}
</style>
